/*
 * @Description:状态管理异步请求
 * @Author: kai.zhou
 * @Date: 2020-03-25 20:46:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-25 15:19:37
 */
import WebApi from "./webApi";
import * as store from "./store";

const actor = (state: any = store.store) => ({
  //获取上门维修省份列表
  getgohomeservice: async (mcc?: any) => {
    if(!(state.getState().defaultState.countryActive.mcc)){
      return;
    }
    let res: any = await WebApi.getgohomeservice({ country: state.getState().defaultState.countryActive.mcc });
    if (res && res.code === 200) {
      state.dispatch(store.setnewService(
        {
          onSiteService: (res.data?.haveMap||{})[1] ||false,
          smartService: (res.data?.haveMap||{})[2]||false,
          haveFaultType: res.data?.haveFaultType||false,
          goHomeServiceName: res.data?.goHomeServiceName||'',
        }
      ));
    }
  },
  // 上门省份
  getgohomeservicelist: async (mcc?: any) => {
    if(!(state.getState().defaultState.countryActive.mcc)){
      return;
    }
    let res: any = await WebApi.getgohomeservicelist({ country: state.getState().defaultState.countryActive.mcc,type:1});
    if (res && res.code === 200) {
      state.dispatch(store.setonSiteList(res.data ||[]));
    }
  },
  // 智能柜省份
  getsmartservicelist: async (mcc?: any) => {
    if(!(state.getState().defaultState.countryActive.mcc)){
      return;
    }
    let res: any = await WebApi.getgohomeservicelist({ country: state.getState().defaultState.countryActive.mcc ,type:2});
    if (res && res.code === 200) {
      state.dispatch(store.setsmartList(res.data ||[]));
    }
  },
  //获取Banner图片
  getBannerImg: async (mcc?: any) => {
    if(!(state.getState().defaultState.countryActive.mcc)){
      return;
    }
    let res: any = await WebApi.getBannerImg({ country: state.getState().defaultState.countryActive.mcc });
    if (res && res.code === 200) {
      let a = res.data && res.data.imgUrl;
      state.dispatch(store.getBannerImg(a));
    }
  },
  //获取国家列表
  getCountries: async () => {
    let res: any = await WebApi.getCountries({});
    if (res && res.code === 200) {
      let a = res.data;
      state.dispatch(store.getCountryList(a));
    }
  },
});

export default actor();
